<template>
  <div class="breadcrumb_box">
    <div class="breadcrumb">
      <div class="">当前位置：</div>
      <a class="breadcrumb_title" :href="PAGE_BASE_URL">首页</a>
      <img class="breadcrumb_right" :src="img.breadcrumb_right">
      <div class="breadcrumb_title">{{firstPage}}</div>
      <img v-if="firstPage" class="breadcrumb_right" :src="img.breadcrumb_right">
      <div class="breadcrumb_title">{{secondPage}}</div>
      <img v-if="secondPage" class="breadcrumb_right" :src="img.breadcrumb_right">
      <div class="breadcrumb_title">{{lsatPage}}</div>
    </div>
  </div>
</template>
<script>
  export default {
    data () {
      return {
        PAGE_BASE_URL:'',
        img:{
          breadcrumb_right: require('../assets/img/hoime_icon/breadcrumb_right.png'),
        }
      }
    },
    props:['firstPage','secondPage','lsatPage'],
    created () {
      this.PAGE_BASE_URL=window.location.origin
    },
    methods: {

    }
  }
</script>
<style lang="scss">
.breadcrumb_box{
  width: 100%;
  height: 52px;
  background-color: #F8F8F8;
  display: flex;
  align-items:center;
  justify-content: center;
  border-top:1px solid #eaeaea;
  
  .breadcrumb{
    width: 1200px;
    color: #333333;
    font-size: 15px;
    display: flex;
    align-items:center;
  }
  .breadcrumb_title{
    color: #333333;
    cursor: pointer;
  }
  .breadcrumb_title:last-child{
    color: #999999;
    cursor: auto;
  }
  .breadcrumb_right{
    width: 6px;
    height: 9px;
    margin: 0 9px;
  }
}
</style>


// WEBPACK FOOTER //
// src/components/Breadcrumb.vue